import type { Project } from '@/lib/projects';

type Props = {
  project: Pick<Project, 'accentColor' | 'statusLabel'>;
  size?: 'sm' | 'md';
};

export function StatusBadge({ project, size = 'md' }: Props) {
  const isSmall = size === 'sm';
  return (
    <span
      className="inline-flex items-center gap-2 rounded-full"
      style={{
        padding: isSmall ? '3px 10px' : '4px 12px',
        background: `color-mix(in srgb, ${project.accentColor} 8%, transparent)`,
        border: `1px solid color-mix(in srgb, ${project.accentColor} 22%, transparent)`,
      }}
    >
      <span
        className="block rounded-full"
        style={{
          width: 6,
          height: 6,
          background: project.accentColor,
          boxShadow: `0 0 10px ${project.accentColor}`,
        }}
      />
      <span
        className="font-mono"
        style={{
          fontSize: isSmall ? 9 : 10,
          fontWeight: 800,
          letterSpacing: '0.1em',
          color: project.accentColor,
          textTransform: 'uppercase',
        }}
      >
        {project.statusLabel}
      </span>
    </span>
  );
}
